import PropTypes from "prop-types";

export default function LoaderIcon(props) {
  LoaderIcon.propTypes = {
    height: PropTypes.string,
    width: PropTypes.string,
  };

  let { height, width } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 28 28"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="#2140A6">
          <g>
            <path
              d="M14 22c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0-22c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3z"
              transform="translate(-174 -292) translate(174 292)"
            />
            <path
              d="M14 22c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0-22c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3z"
              transform="translate(-174 -292) translate(174 292) rotate(90 14 14)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
